module.exports = __webpack_public_path__ + "img/slider_diamond_contractor_small.80883869.png";